function _post(uri, params, id, text = null) {
    $.post(uri, params, function(response) {
        $(id).html(response);
        if (text) {
            $('#has_seleccionado').html($('#agencia_isla option:selected').data('text'));
        }
    });
}

$('body').on('change', '#agencia_isla', function() {
    params = {
        id_ajax: $(this).val()
    };
    _post("/views/layouts/components/_form_isla.php", params, '#agencia_localidad', '#agencia_isla');
    _post("/views/layouts/components/_agencias_fichas.php", params, '#agencias_fichas');
});

$('body').on('change', '#agencia_localidad', function() {
    params = {
        localidad: $(this).val()
    };
    _post("/views/layouts/components/_form_localidad.php", params, '#agencia_agencia', '#agencia_localidad');
    _post("/views/layouts/components/_agencias_fichas.php", params, '#agencias_fichas');
});

$('body').on('change', '#agencia_agencia', function(e) {

    e.preventDefault();

    var agencia = $(this).val();
    if ($(this).hasClass('reserva_agencia')) {
        params = {
            agencia: agencia
        };
        _post("/views/layouts/components/_agencia_reservada.php", params, '#datos_agencia');
        $('#form_paso2_envio').removeClass('hidden');
        $('#titulo_seleccion').removeClass('hidden');
        // $('#datos_agencia').find('input[name=agencia_id]').val($(this).val());
    } else {
        if (agencia != 0) {
            window.open('/agencias/agencia/' + agencia, '_blank');
        }
    }

});

$('body').on('click', '#agencias_fichas .flex_mosaic .img__sepia', function() {
    var agencia = $(this).data('id');

    if (agencia != 0) {
        window.open('/agencias/agencia/' + agencia, '_blank');
    }
});


// WEBPACK FOOTER //
// ./assets/js/map_agencias.js